import * as React from 'react';
import { EventBus } from '@/shared/utils';
import { InstrumentsEventKeys, InstrumentsEvents } from '../events';
import { Instruments } from '@/shared/i18n';

import { InstrumentsForm } from '../ui/instruments-form';
import { useInstruments } from '../hooks/use-instruments';
import InstrumentsActionFeedback from '../ui/elements/action-feedback';
import { ProfileInstrumentLoader } from '../../ui/shared/module-loader';
import { Auth } from 'firebase/auth';

interface InstrumentsScreenProps {
  auth: Auth;
  eventBus: EventBus<InstrumentsEvents>;
  dict: Instruments;
}

const InstrumentsScreen: React.FC<InstrumentsScreenProps> = ({ auth, dict, eventBus }) => {
  const {
    refreshInstruments,
    refreshProfileSkillLevels,
    instruments,
    profileSkillLevels,
    skillLevelsOptions,
    refreshSkillLevels,
    addProfileSkillLevel,
    profileSkillLevelUpdate,
    profileSkillLevelDelete,
    resetStore,
  } = useInstruments(auth, dict);

  React.useEffect(() => {
    eventBus.on(InstrumentsEventKeys.instruments.options, refreshInstruments);
    eventBus.on(InstrumentsEventKeys.instruments.profile, refreshProfileSkillLevels);
    eventBus.on(InstrumentsEventKeys.instruments.skillLevels.get, refreshSkillLevels);
    eventBus.on(InstrumentsEventKeys.instruments.skillLevels.create, addProfileSkillLevel);
    eventBus.on(InstrumentsEventKeys.instruments.skillLevels.update, profileSkillLevelUpdate);
    eventBus.on(InstrumentsEventKeys.instruments.skillLevels.delete, profileSkillLevelDelete);

    return () => {
      resetStore();
      eventBus.off(InstrumentsEventKeys.instruments.options, refreshInstruments);
      eventBus.off(InstrumentsEventKeys.instruments.profile, refreshProfileSkillLevels);
      eventBus.off(InstrumentsEventKeys.instruments.skillLevels.get, refreshSkillLevels);
      eventBus.off(InstrumentsEventKeys.instruments.skillLevels.create, addProfileSkillLevel);
      eventBus.off(InstrumentsEventKeys.instruments.skillLevels.update, profileSkillLevelUpdate);
      eventBus.off(InstrumentsEventKeys.instruments.skillLevels.delete, profileSkillLevelDelete);
    };
  }, [
    eventBus,
    refreshProfileSkillLevels,
    refreshInstruments,
    refreshSkillLevels,
    addProfileSkillLevel,
    profileSkillLevelUpdate,
    profileSkillLevelDelete,
    resetStore,
  ]);

  if (!instruments || !profileSkillLevels || !skillLevelsOptions)
    return (
      <>
        <InstrumentsActionFeedback />
        <ProfileInstrumentLoader key="profile-loader" />
      </>
    );

  return (
    <>
      <InstrumentsActionFeedback />
      <InstrumentsForm
        dict={dict}
        eventBus={eventBus}
        instruments={instruments}
        profileSkillLevels={profileSkillLevels}
        skillLevelsOptions={skillLevelsOptions}
      />
    </>
  );
};

export default InstrumentsScreen;
